import ApiService from '@/services/core/api.service'

const OrganizationService = {
  async get (query) {
    return ApiService.get(`logistics-officer/organizations?${query}`)
  },

  async post (payload) {
    return ApiService.post('logistics-officer/organizations', payload)
  },

  async put (payload) {
    return ApiService.put(`logistics-officer/organizations/${payload.id}`, payload)
  }
}

export default OrganizationService
